<template>
  <div class="card" v-on:click="joinGame">
    <div class="card-header">
      <div class="row justify-content-between">
        <span class="col game-title">{{game.gameName}}</span>
        <span class="col-auto text-right creator">{{game.creator}}</span>
      </div>
    </div>
    <div class="card-body">
      <div>
        <div class="row" v-if="game.startDate">
          <span class="col">Tour :</span>
          <span class="col-auto now" v-if="activeRound <= 1">
            Débute maintenant</span>
          <span class="col-auto" v-else>
            {{activeRound}}</span>
        </div>
        <div class="row"  v-if="game.startDate">
          <span class="col">Début :</span>
          <span class="col-auto">{{convertDate(game.startDate)}}</span>
        </div>
        <div class="row"  v-else>
          <span class="col active">En préparation</span>
        </div>
        <div class="row" v-if="game.endDate">
          <span class="col">Fin :</span>
          <span class="col-auto">{{convertDate(game.endDate)}}</span>
        </div>
        <div class="row">
          <span class="col">Joueurs :</span>
          <span class="col-auto">{{players.length}}
            <img src="/static/people.svg" height="24"/></span>
        </div>
        <div class="row" v-if="game.roundTime">
          <span class="col">Temps par tour :</span>
          <span class="col-auto">{{roundTime}}
            <img src="/static/alarm.svg" height="18"/></span>
        </div>
        <div class="row" v-if="game.locked">
          <div class="col-12">
            <form v-on:submit="joinGame">
              <div class="form-group">
                <label for="gamePassword">
                Mot de passe</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text lock">&#x1F512;</div>
                  </div>
                  <input type="text" class="form-control"
                  maxlength="70"
                  placeholder="Clé d'accès..." v-model="gamePassword">
                </div>
              </div>
            </form>
          </div>
        </div>
        <div v-if="game.onlyFriends">
          <img src="/static/lock-alt.svg" width="20"/>
          Accès restreint aux amis de {{game.creator}} seulement !
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <button v-bind:class="buttonClass">
              JOUER
            </button>
          </div>
          <div class="col-12 text-center" v-on:click="viewGame" v-if="!game.locked">
            <button v-bind:class="buttonClass">
              <font-awesome-icon icon="eye" class="icon"/>
              voir
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iam from '../iam';


const padZero = n => ((n < 10) ? `0${n}` : n);

export default {
  name: 'AccessGameCard',
  props: {
    game: {
      type: Object,
      required: true,
    },
    players: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      gamePassword: undefined,
    };
  },
  computed: {
    roundTime() {
      if (this.game.roundTime < 120) {
        return `${this.game.roundTime} s`;
      }
      return `${this.game.roundTime / 60} min`;
    },
    buttonClass() {
      return {
        btn: true,
        'btn-link': true,
        inactive: this.game.locked && !this.gamePassword,
        active: !this.game.locked || this.gamePassword,
      };
    },
    activeRound() {
      const now = new Date();
      return Math.min(Math.ceil(
        (now.getTime() - Date.parse(this.game.startDate)) / (1000 * this.game.roundTime)),
      this.game.nbRounds);
    },
  },
  methods: {
    convertDate(timestamp) {
      const h = padZero(new Date(Date.parse(timestamp)).getHours());
      const m = padZero(new Date(Date.parse(timestamp)).getMinutes());
      return `${h}h${m}`;
    },
    joinGame(event) {
      event.preventDefault();
      if (this.game.locked && !this.gamePassword) {
        return;
      }
      this.$http.post(`${process.env.LCT_API_URL}/game-players`, {
        username: iam.getConnectedUser().username,
        picture: iam.getConnectedUser().picture,
        password: this.game.locked ? this.gamePassword : undefined,
        activeGameId: this.game.id,
      }).then((response) => {
        sessionStorage.setItem(`${this.game.id}`, `${response.data.id}`);
        if (!this.game.startDate) {
          this.$router.push(`/prepare-games/${this.game.id}`);
        } else {
          this.$router.push(`/games/${this.game.id}`);
        }
      });
    },
    viewGame(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.game.locked) {
        return;
      }
      this.$router.push(`/view/games/${this.game.id}`);
    },
  },
};
</script>

<style scoped>
.inactive{
  color: #757575;
}
.inactive:hover{
  color: #757575;
  text-decoration: none;
}
.active{
  color: #CE0F69;
}
.creator{
  color: #757575;
}
.card-body{
  min-height: 130px;
}
.game-title {
  color: #757575;
  font-weight: 500;
  letter-spacing: .21px;
  font-family: Roboto,arial,sans-serif;
}
.card:hover {
  cursor: pointer;
  border-color: #CE0F69;
}
.now{
  color: #CE0F69;
}
</style>



// WEBPACK FOOTER //
// src/components/AccessGameCard.vue